import { ICommercialBreadcrumbs } from '../../types/commercialBreadcrumbs';
import { IGetBreadcrumbsV1Response } from '../../repositories/seo-sections/entities/breadcrumbs/GetBreadcrumbsV1Response';

export function prepareCommercialBreadcrumbs(response: IGetBreadcrumbsV1Response): ICommercialBreadcrumbs | null {
  const items = response.breadcrumbs || [];

  if (!items.length) {
    return null;
  }

  return {
    breadcrumbs: [...items].sort((a, b) => a.position - b.position).map(({ url, anchor }) => ({ url, title: anchor })),
    schema: response.schema || '',
  };
}
